import AvailabilityBadge from "./AvailabilityBadge";
import HoursPerWeek from "./HoursPerWeek ";
import ProfileVisibility from "./ProfileVisibility";

const modalData=[
{
    id: 'badge',
    title:"Turn on availability badge",
    body:<AvailabilityBadge/>
},
{
    id: 'hpw',
    title:"Hours per week",
    body:<HoursPerWeek/>
},
{
    id: 'pv',
    title:"Edit Profile Visibility",
    body:<ProfileVisibility/>
},
{
    id: 'mc',
    title:"CCCCjdhfjdh",
    body:"CCCfjgudftugjfdijurtyuit"
}
]
export default modalData;